"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_jss_1 = require("react-jss");
var defaultProps = {
    duration: 10000,
    transitionDuration: 500,
};
var useStyles = (0, react_jss_1.createUseStyles)({
    container: {
        position: 'relative',
        width: '100%',
        height: '100%',
    },
    slide: {
        opacity: 0,
        transition: function (props) {
            return "all ease ".concat(props.transitionDuration, "ms");
        },
        position: 'absolute',
        width: '100%',
        height: '100%',
    },
    active: {
        opacity: 1,
    },
});
var SlideShow = function (props) {
    var duration = props.duration, children = props.children, className = props.className;
    var styles = useStyles(props);
    var _a = (0, react_1.useState)(0), activeSlide = _a[0], setActiveSlide = _a[1];
    var size = react_1.default.Children.count(children);
    (0, react_1.useEffect)(function () {
        var timer = setTimeout(function () {
            var active = activeSlide + 1;
            setActiveSlide(active === size ? 0 : active);
        }, duration);
        return function () { return clearTimeout(timer); };
    }, [activeSlide]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.container, className) }, react_1.Children.map(children, function (child, index) {
        var _a;
        if (!(0, react_1.isValidElement)(child))
            return;
        return (0, react_1.cloneElement)(child, {
            className: (0, classnames_1.default)(styles.slide, (_a = {},
                _a[styles.active] = activeSlide === index,
                _a)),
        });
    })));
};
SlideShow.defaultProps = defaultProps;
exports.default = SlideShow;
//# sourceMappingURL=index.js.map